export default class Locale_ProjectVersionsDialog {
	AreYouSureYouWantToMode: string = "Are you sure you want to [[mode]] the entire scenario? This cannot be undone!";
	NotImplementedYet: string = "not implemented yet";
	SelectVersionsToCompare: string = "Select the versions you want to compare";
}